export const metadata = {
  "InvocaAdwords": {
    name: "Invoca for AdWords"
  },
  "FacebookAds": {
    name: "Facebook Ads"
  },
  "GoogleAds": {
    name: "Google Ads"
  },
  "MicrosoftAds": {
    name: "Microsoft Advertising"
  },
  "SFMC": {
    name: "Marketing Cloud"
  },
  "SFSC": {
    name: "Sales Cloud"
  }
};

export const types = Object.keys(metadata);

export default metadata;
